import { z } from 'zod';

import { DocumentTypeCodeZod } from 'types/zod/document-type-code';

export const DocumentTypeZod = z.object({
    document_type_code: DocumentTypeCodeZod,
    notary_required: z.boolean(),
    number_of_witnesses: z.number(),
    name: z.string(),
    notary_2_witnesses_is_and: z.boolean().nullable().optional(),
});
export type DocumentType = z.infer<typeof DocumentTypeZod>;
